exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quizReviewContainer {\n  margin: 5px;\n  min-height: 700px;\n  max-height: 700px;\n  width: 90%;\n  z-index: 10000;\n  overflow: scroll; }\n\n.not-attempt a {\n  color: red; }\n\n.cursor-pointer {\n  cursor: pointer; }\n\n.quiz-review .quiz-header {\n  height: 65px; }\n\n.quiz-review .quiz-header .back-btn {\n    margin-left: 10px;\n    margin-right: 60px; }\n\n.quiz-review .quiz-header .select-attempt {\n    width: 150px;\n    margin-right: 637px; }\n\n.quiz-review .quiz-question-head {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/dashboard/quiz-review/quiz-review.component.scss
// module id = ../../../../../src/app/feature-modules/admin/dashboard/quiz-review/quiz-review.component.scss
// module chunks = main